export const CHANGELOG = [
  {
    version: '1.7.6',
    date: '2025-04-17',
    changes: [
      'Added feedback system with bug reports and feature requests',
      'Added floating feedback button for quick access',
      'Added comment support on feedback items',
      'Added status tracking for feedback items',
      'Added admin controls for feedback management',
      'Updated navigation styling with active state indicators',
      'Added breadcrumb navigation to internal pages',
      'Added dismissible disclaimer footer'
    ]
  },
  {
    version: '1.7.5',
    date: '2025-04-17',
    changes: [
      'Updated bulk update feature to only target "Out of Sync" zones',
      'Improved bulk update confirmation message clarity',
      'Fixed zone filtering logic for bulk operations',
      'Enhanced status-based action handling'
    ]
  },
  {
    version: '1.7.4',
    date: '2025-04-17',
    changes: [
      'Added "Bulk Update Out of Sync Zones" feature',
      'Added confirmation dialog for bulk zone updates',
      'Improved zone status indicators',
      'Enhanced error handling for bulk operations'
    ]
  },
  {
    version: '1.7.3',
    date: '2025-04-17',
    changes: [
      'Fixed core templates appearing in My Templates section',
      'Added proper permission checks for core template management',
      'Improved error handling for template operations',
      'Added dismissible disclaimer footer',
      'Added Cloudflare trademark notice',
      'Added proper spacing for mobile view with disclaimer',
      'Removed duplicate feature list from login page',
      'General stability improvements and bug fixes'
    ]
  },
  {
    version: '1.7.2-beta',
    date: '2025-04-16',
    changes: [
      'Added deployment support for Netlify',
      'Updated landing page layout with improved benefits section',
      'Enhanced hero section with background image',
      'Fixed spacing issues in landing page sections',
      'Improved mobile responsiveness across all pages',
      'Added beta release indicator in navigation'
    ]
  },
  {
    version: '1.7.1-beta',
    date: '2025-04-16',
    changes: [
      'Fixed WAF rules not being properly sent to Cloudflare',
      'Added improved error logging and debugging for WAF rule deployment',
      'Enhanced request retry logic for better reliability',
      'Added beta release channel support'
    ]
  },
  {
    version: '1.7.0',
    date: '2025-04-15',
    changes: [
      'Added version tracking for WAF templates',
      'Added version history viewer for core templates',
      'Enhanced community template sharing with improved visibility',
      'Added visual indicators for template actions (Skip, Block, Challenge)',
      'Improved template management interface',
      'Fixed community template sharing and visibility issues',
      'Added ability to share personal templates with community'
    ]
  },
  {
    version: '1.6.0',
    date: '2025-04-15',
    changes: [
      'Added comprehensive Settings area with Account, Security, and Notifications sections',
      'Implemented email notification preferences management',
      'Added two-factor authentication (2FA) support',
      'Enhanced session management with inactivity detection',
      'Added password change functionality',
      'Improved mobile responsiveness across all settings pages',
      'Added email notification system for security alerts and updates'
    ]
  },
  {
    version: '1.5.9',
    date: '2025-04-14',
    changes: [
      'Rebranded to WAFManager Pro with new orange theme',
      'Enhanced mobile responsiveness across all pages',
      'Improved WAF template management interface',
      'Added new background image to login/signup pages',
      'Added attribution footer to auth pages',
      'Updated DNS proxy status indicators',
      'Improved error handling and retry logic'
    ]
  },
  {
    version: '1.5.8',
    date: '2025-04-13',
    changes: [
      'Added ability to disable WAF rules for a zone',
      'Enhanced WAF rule comparison logic',
      'Improved error handling in edge functions',
      'Added retry mechanism for rate-limited requests',
      'Updated WAF template versioning system'
    ]
  },
  {
    version: '1.5.7',
    date: '2025-04-12',
    changes: [
      'Added community WAF templates section',
      'Implemented template creation form with improved validation',
      'Enhanced form styling with Tailwind Forms plugin',
      'Added ability for users to create and manage their own templates',
      'Improved template management interface with separate core and community sections'
    ]
  },
  {
    version: '1.5.6',
    date: '2025-04-11',
    changes: [
      'Added WAF template versioning with detailed change history',
      'Added version tracking for each template modification',
      'Enhanced template management with version display',
      'Added ability to view version history for each template',
      'Improved template organization with display order',
      'Added visual indicators for template actions (Allow, Block, Challenge)',
      'Enhanced mobile responsiveness for template management'
    ]
  },
  {
    version: '1.5.5',
    date: '2025-04-10',
    changes: [
      'Added DNS proxy status indicators for root and www domains',
      'Added ability to toggle DNS proxy status directly from the interface',
      'Improved WAF status display with "Out of Sync" state',
      'Added resync capability for out-of-sync WAF rules',
      'Enhanced mobile interface with better zone management',
      'Added retry logic for API requests to handle rate limiting',
      'Improved error handling and user feedback'
    ]
  },
  {
    version: '1.5.0',
    date: '2025-04-09',
    changes: [
      'Initial release of WAF template management',
      'Added core WAF rules for common security scenarios',
      'Implemented WAF rule application across multiple zones',
      'Added zone filtering and pagination',
      'Basic account management functionality'
    ]
  }
];